import { addDropdownToggle } from "./addDropdownToggle";
import { initSubnav } from "./initSubnav";

export function navigation() {
  const navigation = document.querySelector("#navbarCollapsedContent");

  if (!navigation) {
    return;
  }

  const hasDropdown = document.querySelectorAll(".js-nav-item-has-children");

  if (hasDropdown) {
    [].slice.call(hasDropdown).forEach(menuItem => {
      addDropdownToggle(menuItem);
      initSubnav(menuItem);
    });
  }
}
